import { Flex } from "rebass/styled-components";

import { Button } from "MVVM/Components/Button";
import { Title2, Body } from "MVVM/Components/Text";
import { Modal } from "MVVM/Components/Wrappers/Existing/modal";

export const OptOutConfirm = ({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => (
  <Modal
    isModalOpen={open}
    setModalOpen={(next: boolean) => !next && onCancel()}
    handleModalClose={undefined}
    disableOutsideClose={false}
  >
    <Flex flexDirection="column" alignItems="flex-start" textAlign="left">
      <Title2 mb={3}>Switch back to the old navigation?</Title2>
      <Body mb={4}>
        You can switch back to the new navigation any time from your account
        menu.
      </Body>
      <Flex pt={[2]} justifyContent="flex-start">
        <Button size="small" flex={true} mt={3} onClick={onConfirm}>
          Switch back
        </Button>
        <Button
          type="button"
          size="small"
          flex={true}
          classification="subtle"
          ml={4}
          mt={3}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </Flex>
    </Flex>
  </Modal>
);
